// extracted by mini-css-extract-plugin
export default {"confirm-modal":"confirmation_confirm-modal__ZYvAU","actions-content":"confirmation_actions-content__I3tOD","border-line":"confirmation_border-line__qyggw"};